import React from "react";
import { Box, CircularProgress } from "@mui/material";

interface LoaderProps {
  size?: number;
  fullScreen?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ size = 50, fullScreen = false }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: fullScreen ? "100vw" : "100%",
        height: fullScreen ? "100vh" : "100%",
        marginTop:25
      }}
    >
      <CircularProgress size={size} />
    </Box>
  );
};

export default Loader;
